import styled from 'styled-components';
import Image from '../../../assets/NeedlesImage.png'

const NeedlesImageContainer = styled.div`
`

const Heading = styled.h2`
    font-family: Nexa;
    font-weight: 700;
    font-style: Bold;
    font-size: 56px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    margin-bottom: 8px;

    @media (max-width: 768px) {
        font-size: 40px;
    }
    @media (max-width: 499px) {
        font-size: 36px;
    }
`

const SubHeading = styled.h3`
    font-family: Open Sans;
    font-weight: 300;
    font-style: Light;
    font-size: 36px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    margin-top: 8px;

    @media (max-width: 768px) {
        font-size: 30px;
    }
    @media (max-width: 499px) {
        font-size: 24px;
    }
`

const ImageContainer = styled.div`
    width: 100%;
    margin: auto;

    img {
        width: 60%;

        @media (max-width: 768px) {
            width: 72%;
        }
        @media (max-width: 499px) {
            width: 85%;
        }
    }
`;

const  NeedlesImage = () => {
    return <NeedlesImageContainer>
        <Heading>Needle Anatomy</Heading>
        <SubHeading>With Basic Needle Shapes</SubHeading>
        <ImageContainer>
            <img src={Image}/>
        </ImageContainer>
    </NeedlesImageContainer>
}

export default NeedlesImage;